import React from "react";
import Header from "../../components/header";
import SpotlightSection from "./components/spotlight_section";
import BusinessSection from "./components/business_section";
import EventTabs from "./components/event_tabs";
import ArbitrationEventSection from "./components/arbitration_event_section/index-beta";
import SearchSectionBeta from "./components/search_section/index-beta";
import FooterBeta from "../../components/footer/index-beta";

const HomePage: React.FC = () => {
    return(
        <div>
            <Header/>
            <SpotlightSection/>
            {/* <EventTabs/> */}
            <ArbitrationEventSection/>

            {/* <SearchSectionBeta/> */}
            {/* <BusinessSection/> */}
            {/* <Footer/> */}
            <FooterBeta/>
        </div>
    )
}

export default HomePage